const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  UNVERIFIED_EMAIL: 'UNVERIFIED_EMAIL',
  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERROR: 'REGISTER_ERROR',
  LOGOUT: 'LOGOUT',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token = false, history = false) => ({
    type: actions.LOGIN_REQUEST,
    payload: token,
    history
  }),
  register: (data = false) => ({
    type: actions.REGISTER_REQUEST,
    payload: data,
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
